export default "__VITE_ASSET__BUolTv$l__"